import { render, staticRenderFns } from "./BodyPresetGridThumbnail.vue?vue&type=template&id=170eb6b7&scoped=true"
import script from "./BodyPresetGridThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyPresetGridThumbnail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BodyPresetGridThumbnail.vue?vue&type=style&index=0&id=170eb6b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170eb6b7",
  null
  
)

export default component.exports